export const tableUtils = {
  methods: {
    setZerosAndSortFunction (columns, row) {
      columns.forEach((column) => {
        if (row[column.field] === undefined) {
          row[column.field] = 0
        }
        if (!this.use_min_filters) {
          column.filterOptions = {enabled: false}
        }
        if (column.minfilter && this.use_min_filters) {
          column.filterOptions = {enabled: true, placeholder: 'Min', filterFn: this.filterFn}
        } else if (column.filterable && this.use_text_filters) {
          column.filterOptions = {enabled: true, placeholder: 'Search'}
        }
      })
      return {columns: columns, row: row}
    },
    filterFn: function (data, filterString) {
      var x = parseInt(filterString)
      return data >= x
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/table_utils.js